export default __webpack_public_path__ + "static/media/logo.753ed429.svg";